import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Title } = Typography;

@inject(
    'FnbAdditionalItemStore',
    'CmsLanguageStore',
)
@observer
class FnbAdditionalItemListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives()
        this.props.FnbAdditionalItemStore.initFnbAdditionalItem();
    }

    // ON CLICK

    createFnbAdditionalItemOnClick = () => {
        const { activeLanguages } = this.props.CmsLanguageStore
        this.props.FnbAdditionalItemStore.initCreateFnbAdditionalItem(activeLanguages);
    }

    updateFnbAdditionalItemOnClick = (fnbAdditionalItemId) => {
        const { activeLanguages } = this.props.CmsLanguageStore
        this.props.FnbAdditionalItemStore.initUpdateFnbAdditionalItem(fnbAdditionalItemId, activeLanguages);
    }

    deleteFnbAdditionalItemOnClick = (fnbAdditionalItemId) => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Delete Fnb Additional Item'),
            content: t('Are you sure to delete this item?'),
            okText: t('Yes'),
            cancelText: t('Cancel'),
            onOk: () => { this.deleteUpdateFnbAdditionalItemOnOk(fnbAdditionalItemId); }
        });
    }

    // ON OK

    deleteUpdateFnbAdditionalItemOnOk = (fnbAdditionalItemId) => {
        this.props.FnbAdditionalItemStore.deleteUpdateFnbAdditionalItem(fnbAdditionalItemId).then(isSuccess => {
            if (isSuccess) {
                notification['success']({
                    message: 'Success',
                    description: 'FnB Additional Item has been successfully updated.',
                    duration: 3
                });
            } else {
                notification['error']({
                    message: 'Error',
                    description: 'Unexpected issue occured. Please contact your administrator.',
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('FnB Item'),
                dataIndex: 'fnbTaskName',
                key: 'fnbTaskName',
                ...this.getColumnSearchProps('fnbTaskName')
            },
            {
                title: t('Option Name'),
                dataIndex: 'optionName',
                key: 'optionName',
                ...this.getColumnSearchProps('optionName')
            },
            {
                title: t('Control Type'),
                dataIndex: 'controlType',
                key: 'controlType',
                ...this.getColumnSearchProps('controlType'),
                render: controlType => {
                    if (controlType === 'radio') {
                        return t('Radio List');
                    }

                    return t('Multi Check List');
                }
            },
            {
                title: t('Action'),
                dataIndex: 'fnbAdditionalItemId',
                key: 'action',
                render: fnbAdditionalItemId => (
                    <span>
                        <Button onClick={() => this.updateFnbAdditionalItemOnClick(fnbAdditionalItemId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteFnbAdditionalItemOnClick(fnbAdditionalItemId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            const { t } = this.props;
            return (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={`${t('Search')} ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            )
        },
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { t } = this.props;
        const {
            fnbAdditionalItems,
            fnbAdditionalItemListLoading
        } = this.props.FnbAdditionalItemStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>{t('List')}</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createFnbAdditionalItemOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={fnbAdditionalItemListLoading}>
                        <Table columns={this.getColumns()} dataSource={fnbAdditionalItems} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(FnbAdditionalItemListPage);